import { Component, Input, HostBinding } from '@angular/core'

@Component({
  standalone: false,
  selector: 'se-tag-group',
  templateUrl: './tag-group.component.html',
  
})
export class SeTagGroupComponent {

  @Input('se-data-inline') inline: string

  @HostBinding('class.se-tag-group') baseClass: boolean = true
  @HostBinding('class.se-tag-group--inline') get inlineClass(): boolean { return !!this.inline }

  constructor() {
    // noop
  }

}
